import { findKey } from "lodash";
import { PostHog } from "posthog-js";

import { Option } from "components/FormHelpers";
import { createAssetKYWRoyaltyAccount } from "services/assets";
import { AssetKYWRoyaltyAccount } from "services/assets/types";
import { RoyaltyAccountCredentials } from "services/royaltyAccount/types";
import {
  ADMINMP,
  ASCAP,
  BMI,
  SESAC,
  SONY,
} from "services/royaltyPayor/constants";

import { ErrorInfo } from "./types";

export const trackSuccessfulConnection = (
  username: string,
  subaccountName: string,
  assetId: string,
  royaltyPayorName: string,
  posthog: PostHog,
) => {
  posthog?.capture("Successfully connected royalty account", {
    Username: username,
    Subaccount: subaccountName,
    "Asset Id": assetId,
    RoyaltyPayor: royaltyPayorName,
  });
};

const getRoyaltyPayorName = (royaltyPayorId: string) =>
  findKey(
    {
      AdminMP: ADMINMP,
      ASCAP,
      BMI,
      SESAC,
      "Sony Music Publishing": SONY,
    },
    v => v === royaltyPayorId,
  );
export const handleConnectAccount = async (
  verifiedAccount: RoyaltyAccountCredentials,
  subaccount: Option | null,
  royaltyPayorId: string,
  errorSetter: (error: ErrorInfo | null) => void,
  posthog: PostHog,
): Promise<AssetKYWRoyaltyAccount> => {
  errorSetter(null);
  try {
    const { password, username } = verifiedAccount;
    const subaccountId = subaccount?.value ?? null;
    const subaccountName = subaccount?.display ?? null;

    const asset = await createAssetKYWRoyaltyAccount({
      username,
      password,
      subaccount_id: subaccountId,
      subaccount_name: subaccountName,
      royalty_payor_id: royaltyPayorId,
    });
    const royaltyPayorName = getRoyaltyPayorName(royaltyPayorId);
    trackSuccessfulConnection(
      username,
      subaccountName,
      String(asset.id),
      royaltyPayorName,
      posthog,
    );
    return asset;
  } catch (e) {
    errorSetter({
      date: new Date(),
      errorType: "connection",
      message: e as string,
    });
  }
};
